import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {SessionActions} from '../../../../shared/actions';
import {AbstractListView} from '../../../../core/visbos-core/ui/components/abstract-list-view';
import {DatatableComponent} from '../../../../core/visbos-core/ui/components/datatable/datatable.component';
import {Asset} from '../../../../shared/view-model/store-management/asset.type';

@Component({
  selector: 'vb-assets-list',
  templateUrl: './assets-list.component.html',
  styleUrls: ['./assets-list.component.css']
})
export class AssetsListComponent extends AbstractListView implements OnInit {

  @Input()
  assets = [];

  @ViewChild('assetTable')
  table: DatatableComponent;

  @Output()
  onEditAsset: EventEmitter<Asset> = new EventEmitter();

  messages = {
    emptyMessage: 'Keine Gegenstände vorhanden',
    totalMessage: 'Gegenstände insgesamt'
  };

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.columns = [
      {prop: 'identities.0.ean', name: 'EPC'},
      {prop: 'label', name: 'Bezeichner'},
      //{prop: 'product_batch', name: 'Charge / MHD', cellTemplate: this.batchCellTmpl},
      {name: 'Seriennr.', prop: 'serial_no'},
      {name: 'Inventarnr.', prop: 'inventory_no'},
      {name: 'Bestandszähler', prop: 'stock_count'},
      {name: 'Standort', prop: 'location.label'},
      {prop: 'updated_at', name: 'Letzte Änderung', cellTemplate: this.table.formatDateTimeTmpl},
    ];

  }

  editAssetClicked(asset) {
    this.onEditAsset.emit(asset);
  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/asset-management/components/assets-list/assets-list.component.ts